import { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import { Lock } from "./../../components/Lock";
// import { useFormatter } from "../../hooks/useFormatter";

type OverviewBlockProps = {
  section: string;
  type: "list" | "text";
  values: string[];
  visible: boolean;
};

type ProductDetailOverviewProps = {
  analyticsDetail: any;
  info: any;
  pName: string;
};

export const ProductDetailOverview = ({
  info,
  pName,
}: ProductDetailOverviewProps) => {
  const { t } = useTranslation();
  const { isLogged } = useAuth();
  const blocks = useMemo(() => {
    const blks: OverviewBlockProps[] = [];

    let blk: OverviewBlockProps = {
      section: "",
      type: "text",
      values: [],
      visible: true,
    };

    // if (info.geo) {
    //   blk.section = "Country";
    //   blk.values = [t(`geo-${info.geo.toLowerCase()}`)];

    //   blks.push({ ...blk });
    // }

    // if (info.positions !== false) {
    //   blk.section = "Stocks";
    //   blk.values = [info.positions];
    //   blk.type = "text";

    //   blks.push({ ...blk });
    // }

    blk.section = "Markets";
    blk.values = [info.rules.markets.join(", ")];
    blk.type = "text";

    blks.push({ ...blk });

    if (info.rules.investmentUniverse) {
      blk.section = "Investment Universe";
      blk.values = info.rules.investmentUniverse;
      blk.type = "list";

      blks.push({ ...blk });
    }

    if (info.rules.minimumDailyLiquidity) {
      blk.section = "Minimum Daily Liquidity";
      blk.values = info.rules.minimumDailyLiquidity;
      blk.type = "list";

      if (!isLogged) {
        blk.visible = false;
      }

      blks.push({ ...blk });
    }

    if (info.rules.allocationRules) {
      blk.section = "Allocation rules";
      blk.values = info.rules.allocationRules;
      blk.type = "list";

      if (!isLogged) {
        blk.visible = false;
      }

      blks.push({ ...blk });
    }

    if (info.rules.selectionRules) {
      blk.section = "Selection rules";
      blk.values = info.rules.selectionRules;
      blk.type = "list";

      if (!isLogged) {
        blk.visible = false;
      }

      blks.push({ ...blk });
    }

    if (info.rules.rankingRules) {
      blk.section = "Ranking rules";
      blk.values = info.rules.rankingRules;
      blk.type = "list";

      if (!isLogged) {
        blk.visible = false;
      }

      blks.push({ ...blk });
    }

    if (info.rules.benchmark) {
      blk.section = "Benchmark";
      blk.values = [info.rules.benchmark];
      blk.type = "text";

      blk.visible = true;

      blks.push({ ...blk });
    }

    if (info.rules.rebalance) {
      blk.section = "Rebalance";
      blk.values = info.rules.rebalance;
      blk.type = "text";

      blk.visible = true;

      blks.push({ ...blk });
    }

    return blks;
  }, [
    info?.rules?.allocationRules,
    info?.rules?.benchmark,
    info?.rules?.investmentUniverse,
    info?.rules?.markets,
    info?.rules?.minimumDailyLiquidity,
    info?.rules?.rankingRules,
    info?.rules?.rebalance,
    info?.rules?.selectionRules,
    isLogged,
  ]);
  return (
    <Row className="g-0 p-1">
      <Col sm={12} className="mt-3">
        <div className="px-2">
          <p className="d-flex justify-content-around flex-wrap">
            {info.geo && (
              <span className="">
                <span className="text-muted">Country:</span>
                &nbsp;
                {t(`geo-${info.geo.toLowerCase()}`)}
              </span>
            )}
            {info.positions !== false && (
              <span>
                <span className="text-muted">Stocks:</span>
                &nbsp;
                {info.positions}
              </span>
            )}
          </p>
        </div>
      </Col>
      {blocks.map((block, idx) => (
        <OverviewBlock key={idx} {...block} />
      ))}
      {/* 
      <Col sm={12} className="mt-0">
        <h5 className="product-detail-subtitle">Markets</h5>
        <div
          className="px-2"
          dangerouslySetInnerHTML={{
            __html: info.rules.markets.join(", "),
          }}
        />
      </Col>
      {info.rules.investmentUniverse && (
        <Col sm={12} className="mt-2">
          <h5 className="product-detail-subtitle">Investment Universe</h5>
          <ul className="px-2">
            {info.rules.investmentUniverse.map(
              (rule: string, index: number) => (
                <li
                  key={`universe_${index}`}
                  dangerouslySetInnerHTML={{
                    __html: rule,
                  }}
                />
              )
            )}
          </ul>
        </Col>
      )}
      {info.rules.minimumDailyLiquidity && (
        <Col sm={12} className="mt-2">
          <h5 className="product-detail-subtitle">Minimum Daily Liquidity</h5>
          <ul className="px-2">
            {info.rules.minimumDailyLiquidity.map(
              (rule: string, index: number) => (
                <li
                  key={`liquidity_${index}`}
                  dangerouslySetInnerHTML={{
                    __html: rule,
                  }}
                />
              )
            )}
          </ul>
        </Col>
      )}
      {info.rules.allocationRules && (
        <Col sm={12} className="mt-2">
          <h5 className="product-detail-subtitle">Allocation rules</h5>
          <ul className="px-2">
            {info.rules.allocationRules.map((rule: string, index: number) => (
              <li
                key={`allocation_${index}`}
                dangerouslySetInnerHTML={{
                  __html: rule,
                }}
              />
            ))}
          </ul>
        </Col>
      )}
      {info.rules.selectionRules && (
        <Col sm={12} className="mt-2">
          <h5 className="product-detail-subtitle">Selection rules</h5>
          <ul className="px-2">
            {info.rules.selectionRules.map((rule: string, index: number) => (
              <li
                key={`selection_${index}`}
                dangerouslySetInnerHTML={{
                  __html: rule,
                }}
              />
            ))}
          </ul>
        </Col>
      )}
      {info.rules.benchmark && (
        <Col sm={12} className="mt-2">
          <h5 className="product-detail-subtitle">Benchmark</h5>
          <ul className="px-2">
            <li
              key={`benchmark_0`}
              dangerouslySetInnerHTML={{
                __html: info.rules.benchmark,
              }}
            />
          </ul>
        </Col>
      )}
      {info.rules.rebalance && (
        <Col sm={12} className="mt-2">
          <h5 className="product-detail-subtitle">Rebalance</h5>
          <ul className="px-2">
            {info.rules.rebalance.map((rule: string, index: number) => (
              <li
                key={`rebalance_${index}`}
                dangerouslySetInnerHTML={{
                  __html: rule,
                }}
              />
            ))}
          </ul>
        </Col>
      )} */}
    </Row>
  );
};

const OverviewBlock = ({
  section,
  type,
  values,
  visible,
}: OverviewBlockProps) => {
  return !visible ? (
    <Lock sentence="Subscribe to access the detailed rules.">
      <Col sm={12}>
        <div className="overview_block app-lock-content">
          <p className="overview_block_title">{section}</p>
          <div className="overview_block_content">
            {type === "list" ? (
              <ul>
                {values.map((item, idx) => (
                  <li key={idx}>
                    <h5>{item}</h5>
                  </li>
                ))}
              </ul>
            ) : (
              <h5>{values}</h5>
            )}
          </div>
        </div>
      </Col>
    </Lock>
  ) : (
    <Col sm={12}>
      <div className="overview_block">
        <p className="overview_block_title">{section}</p>
        <div className="overview_block_content">
          {type === "list" ? (
            <ul>
              {values.map((item, idx) => (
                <li key={idx}>
                  <h5>{item}</h5>
                </li>
              ))}
            </ul>
          ) : (
            <h5>{values}</h5>
          )}
        </div>
      </div>
    </Col>
  );
};
